import type { FC } from 'react';
import { useCallback, useEffect } from 'react';

import { HEADER_HEIGHT } from '@zen/Layout';

import { useForm } from '../useForm';

interface Props {
  additionalYOffset?: number;
}

const ScrollToFirstError: FC<Props> = ({ additionalYOffset = 0 }) => {
  const { errors, isValid, submitCount } = useForm();
  const hasErrors: boolean = Object.keys(errors).length > 0;

  const scrollTo = useCallback(
    (element: Element): void => {
      const scrollableAncestor = element.closest('.js-element-scrollable') || window;
      const HEADER_ADDITIONAL_OFFSET = 10;

      const y: number =
        element.getBoundingClientRect().top + window.scrollY - HEADER_HEIGHT - HEADER_ADDITIONAL_OFFSET - additionalYOffset;

      scrollableAncestor?.scrollTo?.({ top: y, behavior: 'smooth' });
    },
    [additionalYOffset]
  );

  useEffect(() => {
    if (isValid || !hasErrors || submitCount === 0) return;

    const errorElements: NodeListOf<Element> = document.querySelectorAll('.js-field-error');

    if (errorElements.length > 0) {
      scrollTo(errorElements[0]);
    }
  }, [submitCount, hasErrors]);

  return null;
};

export default ScrollToFirstError;
